/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Status } from './Status';
import {
    StatusFromJSON,
    StatusFromJSONTyped,
    StatusToJSON,
} from './Status';
import type { StatusCodes } from './StatusCodes';
import {
    StatusCodesFromJSON,
    StatusCodesFromJSONTyped,
    StatusCodesToJSON,
} from './StatusCodes';

/**
 * 
 * @export
 * @interface RedAppWhiteListResponse
 */
export interface RedAppWhiteListResponse extends Status {
    /**
     * 
     * @type {Array<string>}
     * @memberof RedAppWhiteListResponse
     */
    redApps: Array<string>;
}

/**
 * Check if a given object implements the RedAppWhiteListResponse interface.
 */
export function instanceOfRedAppWhiteListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "redApps" in value;

    return isInstance;
}

export function RedAppWhiteListResponseFromJSON(json: any): RedAppWhiteListResponse {
    return RedAppWhiteListResponseFromJSONTyped(json, false);
}

export function RedAppWhiteListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedAppWhiteListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...StatusFromJSONTyped(json, ignoreDiscriminator),
        'redApps': json['redApps'],
    };
}

export function RedAppWhiteListResponseToJSON(value?: RedAppWhiteListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...StatusToJSON(value),
        'redApps': value.redApps,
    };
}

